import { cacheExchange, Client, fetchExchange } from 'urql';

export const createClient = (url: string, suspense = true): Client => {
  const client = new Client({
    fetchOptions: {
      credentials: 'include',
    },
    exchanges: [cacheExchange, fetchExchange],
    suspense,
    url,
  });

  return client;
};
